// extracted by mini-css-extract-plugin
export default {"tippy":"Tippy_tippy__1U-vS","fadeIn":"Tippy_fadeIn__GPEBX"};